import { create } from 'zustand';
import { Club } from '../types/types';

interface ClubState {
  myClub: Club | null;
  setMyClub: (clubs: Club) => void;
  clubs: Club[];
  setClubs: (clubs: Club[]) => void;
  setClubLoginTime: (id: number) => void;
}

export const useClubStore = create<ClubState>((set) => ({
  myClub: null,
  clubs: [],
  setMyClub: (myClub) => set({ myClub }),
  setClubs: (clubs) => set({ clubs }),
  setClubLoginTime: (id) => {
    const currentDateTime = new Date();
    const formattedDateTime = currentDateTime
      .toISOString()
      .slice(0, 19)
      .replace('T', ' ')
      .replace(/-/g, '/');
    set((state) => {
      const updatedClubs = state.clubs.map((club) =>
        club.id === id ? { ...club, loginTime: formattedDateTime } : club,
      );
      updatedClubs.sort(
        (a, b) =>
          new Date(b.loginTime ?? '1970-01-01').getTime() -
          new Date(a.loginTime ?? '1970-01-01').getTime(),
      );
      return { clubs: updatedClubs };
    });
  },
}));
